import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrCameraIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M22 5H17.54L15.84 2.45C15.65 2.17 15.34 2 15.01 2H9.01C8.68 2 8.36 2.17 8.18 2.45L6.48 5H2C0.9 5 0 5.9 0 7V21C0 22.1 0.9 23 2 23H22C23.1 23 24 22.1 24 21V7C24 5.9 23.1 5 22 5ZM22 21H2V7H7C7.33 7 7.65 6.83 7.83 6.55L9.53 4H14.46L16.16 6.55C16.35 6.83 16.66 7 16.99 7H21.99V21H22Z" fill={color}/>
    <path d="M12 8C8.69 8 6 10.69 6 14C6 17.31 8.69 20 12 20C15.31 20 18 17.31 18 14C18 10.69 15.31 8 12 8ZM12 18C9.79 18 8 16.21 8 14C8 11.79 9.79 10 12 10C14.21 10 16 11.79 16 14C16 16.21 14.21 18 12 18Z" fill={color}/>
  </BaseIcon>
));

AttrCameraIcon.displayName = 'AttrCameraIcon';
